import { formatString } from '@doda/common/src/utils/stringUtil';
import { getJobCountRange } from './getJobCountRange';

const KEYWORDS_TEMPLATE_COMMON = '%s,資格,%s転職,求人,求人情報,doda';

const KEYWORDS_TEMPLATE_1PAGE = KEYWORDS_TEMPLATE_COMMON;

const KEYWORDS_TEMPLATE_2PAGE = `%sページ,%s件-%s件,${KEYWORDS_TEMPLATE_COMMON}`;

/** createKeywords Props */
interface Arguments {
  /** 表示中のページ数 */
  currentPage: number;
  /** 1ページあたりに表示する求人数 */
  displayJobCountPerPage: number;
  /** 資格名 */
  qualificationName: string;
  /** 地域や年収などのオプションテキスト */
  optionText: string;
  /** 求人数 */
  jobCount: number;
}

/**
 * metaタグのkeywordsテキストを生成する
 * @param {number} param.currentPage 表示中のページ数
 * @param {number} param.displayJobCountPerPage 1ページあたりに表示する求人数
 * @param {string} param.qualificationName 資格名
 * @param {string} param.optionText 地域や年収などのオプションテキスト
 * @param {number} param.jobCount 求人数
 * @returns {string} keywordsテキスト
 */
export const createKeywords = ({
  currentPage,
  displayJobCountPerPage,
  qualificationName,
  optionText,
  jobCount,
}: Arguments): string => {
  const { first, last } = getJobCountRange(
    jobCount,
    currentPage,
    displayJobCountPerPage
  );

  // 空文字の考慮
  const optionTextWithComma = optionText ? `${optionText.slice(0, -1)},` : '';

  if (currentPage > 1) {
    return formatString(
      KEYWORDS_TEMPLATE_2PAGE,
      [currentPage, first, last, qualificationName, optionTextWithComma].map(
        String
      )
    );
  }

  return formatString(
    KEYWORDS_TEMPLATE_1PAGE,
    [qualificationName, optionTextWithComma].map(String)
  );
};
